import styled from 'styled-components';

export const ContMain = styled.div`
  margin-left: 180px !important;
  overflow-x: none;

  @media screen and (max-width: 1024px) {
      margin-left: 0px !important;
  }
`;